import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import Ourlogo from "components/sidebar/components/Ourlogo";
import Brand from "components/sidebar/components/Brand";

function Content({ routes }) {
  
  let activeBg = useColorModeValue("gray.100", "navy.700");
  let inactiveBg = useColorModeValue("white", "navy.900");
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue("gray.400", "gray.400");

  const location = useLocation();

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.path === "/login") return null;
      return (
        <NavLink to={route.layout + route.path} key={index}>
          <Box
            display="flex"
            alignItems="center"
            py="12px"
            ps="16px"
            my="8px"
            borderRadius="8px"
            bg={activeRoute(route.layout + route.path) ? activeBg : inactiveBg}
            color={activeRoute(route.layout + route.path) ? activeColor : inactiveColor}
            _hover={{ bg: activeBg, color: activeColor }}
          >
            <Flex align="center" justify="center" w="30px">
              {route.icon}
            </Flex>
            <Text ml="12px">{route.name}</Text>
          </Box>
        </NavLink>
      );
    });
  };

  return (
    <Flex direction="column" height="100%">
      <Box>
        <Flex direction="column" pt="25px">
          <Brand />
          {createLinks(routes)}
        </Flex>
      </Box>
      <Box mt="auto" mb="20px">
      {/*<Ourlogo />*/}
      </Box>
    </Flex>
  );
}

Content.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Content;
